import React, { Component, useEffect, useState } from 'react';
import { Show, List, TabbedShowLayout, Tab, Datagrid, BooleanField, EditButton, TextField, ReferenceManyField, Button, DateField, TopToolbar, RefreshButton, ListButton, ExportButton } from 'react-admin';
import CustomModal from '../digitalOrders/CustomModal/CustomModal';
import { CommonHeaderOption, RUN_TIME_API_ENDPOINT } from '../common/common';
import moment from 'moment';
import Swal from 'sweetalert2';
import GetAppIcon from '@mui/icons-material/GetApp';

// const topToolbarStyle = {
//     zIndex: 2,
//     display: 'inline-block',
//     float: 'right',
// };
const apiUrl = RUN_TIME_API_ENDPOINT;

const ShowActions = (props) => {
    // const digitalOrderStatusKeyMappings = getLocalStorageKey('order_status_key_mappings');
    const [openModal, setOpenModal] = useState(false);
    const [openMessageModal, setOpenMessageModal] = useState(false);
    const [isResendBtnDisable, setIsResendBtnDisable] = useState(false);

        // this.state = {
        //     openModal: false,
        //     openMessageModal: false,
        //     isResendBtnDisable: false,
        // };
    // open modal function
    const onOpenModal = () => {
        setOpenModal(true);
        // this.setState({ openModal: true });
    };

    const onCloseModal = () => {
        setOpenModal(false);
        // this.setState({ openModal: false });
    };

    const onOkModal = (data) => {
        setOpenModal(false);
        setOpenMessageModal(true);
        // this.setState({ openModal: false, openMessageModal: true });
        // console.log(this.state.openMessageModal,data.order_number);
        const url = `${apiUrl}/promotions/${data.id}/send_promotion_notification`;
        const options = CommonHeaderOption()
        options.method = "POST";
        options.body = JSON.stringify({});

        fetch(url, options)
            .then(res => {
                return res.json();
            })
            .then(json => {
                console.log('json ===>', json.data);
                // if (json.data.resend_status === 'Re-sending') {
                    setIsResendBtnDisable(true);
                // this.setState({ isResendBtnDisable: true });
                // this.props.fromChildToParentCallback(true);
                // }
            });
    };

    // open msg modal function
    const onCloseMessageModal = () => {
        setOpenMessageModal(false);
        // this.setState({ openMessageModal: false });
    };

    const onOkMessageModal = () => {
        setOpenMessageModal(false);
        // this.setState({ openMessageModal: false });
    };

    const callExport = (e, data) => {
        const options = CommonHeaderOption();
        const apiUrl = RUN_TIME_API_ENDPOINT;
        e.preventDefault();
        options.method = 'GET';
        fetch(`${apiUrl}/${props.resource}_sdo_csv/${data.id}`, options)
            .then(res => {
                return res.json();
            }).then(jsonD => {
                console.log('json= inside callback', jsonD.data);
                const msg = jsonD.data ? jsonD.data[0].message : '';
                Swal.fire({
                    html: msg,
                    icon: 'success',
                })
            });
    }

        const { permissions, basePath, data, total, resource } = props;
        const csvResource = 'empty_data';
        console.log('data', data);

        return (
            <TopToolbar className="toolbar-center-align">
                {
                    data && moment(new Date()).format("YYYY-MM-DD") <= moment(data.starts_at).format("YYYY-MM-DD") &&
                    <Button
                        className="custom-button resend-button"
                        disabled={!!isResendBtnDisable}
                        onClick={onOpenModal}
                    >
                        <span className="button-spacing-left">Re-send Promotion</span>
                    </Button>
                }
                {data && !!openModal ?
                    <CustomModal open={openModal}
                        onCloseModal={onCloseModal}
                        showCancel={true}
                        text="Are you sure you want to re-send this promotion ?"
                        onOkModal={() => onOkModal(data)}
                    />
                    : null}
                {data && !!openMessageModal ?
                    <CustomModal open={openMessageModal}
                        onCloseModal={onCloseMessageModal}
                        showCancel={false}
                        text="Your promotion is being re-sent."
                        onOkModal={onOkMessageModal}
                    />
                    : null}
                <RefreshButton />
                <ListButton basePath={basePath} />
                    {/* <ExportButton
                        onClick={e => this.callExport(e, data)}
                        disabled={total === 0}
                        sort={data && data.created_at}
                        resource={csvResource}
                    /> */}
                    <div>
                        <button className="export-button"
                            onClick={(e) => callExport(e, data)}
                            disabled={total === 0}
                            sort={data && data.created_at}
                        >
                            {<GetAppIcon />}
                            <span>Export</span>
                        </button>
                    </div>
            </TopToolbar>
        );
};

const ShowTitle = ({ record }) => {
    return record && <span>Promotion {record.name}</span>;
};

const PromotionShow = (props) => {

        const [loadingShow, setLoadingShow] = useState(false);
        const [detailImage, setDetailImage] = useState('');
        const [listImage, setListImage] = useState('');
        const [summary, setSummary] = useState('');
        const [title, setTitle] = useState('');
        const [description, setDescription] = useState('');

        useEffect(() => {
            const options = CommonHeaderOption();
            const apiUrl = RUN_TIME_API_ENDPOINT;
            options.method = 'GET';
            setLoadingShow(true);
            // this.setState({ loadingShow: true });
            fetch(`${apiUrl}/promotions/${props?.id}`, options)
                .then(res => {
                    return res.json();
                }).then(jsonD => {
                    console.log('data', jsonD.data);
                    let data = jsonD.data;
                    setDetailImage(data.detail_image);
                    setListImage(data.preview_image);
                    setSummary(data.summary);
                    setTitle(data.title);
                    setDescription(data.description);
                    // this.setState({
                    //     detailImage: data.detail_image, listImage: data.preview_image,
                    //     summary: data.summary, title: data.title, description: data.description
                    // })
                });
        },[])

        // const { props, permissions, state } = this;
        console.log('xxxx', props);
        return (
            <Show actions={<ShowActions permissions={props?.permissions} />} {...props} title={<ShowTitle />}>
                <TabbedShowLayout className="tab-scroll">
                    <Tab label="Details" contentClassName="scrollTab">
                        <TextField label="Title" source="title" allowEmpty />
                        <DateField label="Start date" source="starts_at" showTime />
                        <DateField label="End date" source="ends_at" showTime />
                        {/* <TextField label="Description" source="description" allowEmpty /> */}
                        <DateField 
                        // label="Created at" 
                        source="created_at" showTime />
                        <DateField label="Updated at" source="updated_at" showTime />
                    </Tab>
                    <Tab label="Preview" sort={{ field: 'created_at', order: 'DESC' }} contentClassName="scrollTab promotion-showpage">
                        <div className="promotion-preview-heading">Promotion Notification Popup</div>
                        <div className="promotion-popup-page-preview">
                            <div className="promotion-popup-preview">
                                <div className="lr-onboarding__close">
                                    <span className="icon-close" />
                                </div>
                                <div className="lr-loyalty__schemes__row__description">
                                    <div>
                                        <img src={detailImage} />
                                    </div>
                                </div>
                                <button className="preview-page-btn"><span>View</span></button>
                            </div>
                        </div>
                        <div className="promotion-preview-heading">Promotion List page</div>
                        <div className="promotion-page-preview">
                            <div className="lr-main-view__header">
                                <span className="icon-back"></span>
                                <span className="preview-page-header">Promotions</span>
                            </div>
                            <div className="lr-loyalty__schemes__row__heading">{title}</div>
                            <div className="lr-loyalty__schemes__row_image">
                                <img src={listImage} />
                            </div>
                            <div className="lr-loyalty__schemes__row__description" dangerouslySetInnerHTML={{ __html: summary }}>
                                {/*  Rendering html dynamically */}
                            </div>
                            <button className="preview-page-btn"><span>Know More</span></button>
                        </div>
                        <div className="promotion-preview-heading">Promotion Detail page</div>
                        <div className="promotion-page-preview">
                            <div className="lr-main-view__header">
                                <span className="icon-back"></span>
                                <span className="preview-page-header">Promotion Detail</span>
                            </div>
                            <div className="lr-loyalty__schemes__row__heading">
                                {title}
                            </div>
                            <div className="lr-loyalty__schemes__row__description">
                                {/* <div>
                                <img src={detailImage} />
                            </div> */}
                                <div dangerouslySetInnerHTML={{ __html: description }}>
                                    {/* Rendering html dynamically  */}
                                </div>
                            </div>
                        </div>
                    </Tab>
                    <Tab label="Sold To List">
                        <ReferenceManyField
                            addLabel={false}
                            reference="promotion_sold_to_list"
                            target="id"
                            className="tab-pagination"
                        >
                            <List {...props} 
                            filterDefaultValues={{ id: props.id }} 
                            bulkActionButtons={false} exporter={false}>
                                <Datagrid className="tab-data-grid">
                                    <TextField label="Name" source="name" allowEmpty />
                                    <TextField label="Sap Code" source="sap_code" allowEmpty />
                                    <DateField label="Notification Sent At" source="notification_sent_at" allowEmpty showTime />
                                    <BooleanField label="Notification Status" source="notification_status" allowEmpty />
                                    <TextField label="Send Error" source="send_error" />
                                    <BooleanField label="Read Status" source="read_status" />
                                    <BooleanField label="From Push Notification" source="from_push_notification" />
                                </Datagrid>
                            </List>
                        </ReferenceManyField>
                    </Tab>
                </TabbedShowLayout>
            </Show>
        );
}

export default PromotionShow;